import { render, staticRenderFns } from "./JLabel.vue?vue&type=template&id=6b097a65"
import script from "./JLabel.vue?vue&type=script&lang=js"
export * from "./JLabel.vue?vue&type=script&lang=js"
import style0 from "./JLabel.vue?vue&type=style&index=0&id=6b097a65&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports